import type { HTMLAttributes } from 'react';
import { cx } from '../utils/cx.js';
import styles from './EmptyValue.module.css';

export type EmptyValueKind = 'missing' | 'none' | 'zero';

export type EmptyValueProps = Omit<HTMLAttributes<HTMLSpanElement>, 'children'> & {
  /**
   * `missing` — field not set (contact, text).
   * `none` — no items in a collection.
   * `zero` — numeric zero that should not read as a real amount/count.
   */
  kind?: EmptyValueKind;
  /** Override default French label for `kind`. */
  label?: string;
};

const DEFAULT_LABEL: Record<EmptyValueKind, string> = {
  missing: 'Vide',
  none: 'Aucun',
  zero: 'Aucun',
};

/** Inline empty marker for table cells and detail fields — replaces bare "—" / "0". */
export function EmptyValue({
  kind = 'missing',
  label,
  className,
  ...rest
}: EmptyValueProps) {
  const text = label?.trim() || DEFAULT_LABEL[kind];
  return (
    <span
      className={cx(styles.root, className)}
      data-wp-empty-value={kind}
      {...rest}
    >
      {text}
    </span>
  );
}
